<template>
  <v-app id="inspire">
    <v-overlay absolute :value="loading"
      ><v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-app-bar app color="blue" v-if="userAuth">
      <div class="d-flex align-center" :xsOnly="true">
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Falcon</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" dark v-bind="attrs" v-on="on">
              {{
                userAuth.fullName
                  ? userAuth.fullName
                  : userAuth.email.split("@")[0]
              }}
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item>
              <v-list-item-title>Mi Perfil</v-list-item-title>
            </v-list-item> -->
            <v-list-item>
              <v-list-item-title @click.prevent="logout">
                <v-btn text small>Cerrar sesión</v-btn>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app v-if="userAuth">
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-icon>mdi-face-agent</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>
              {{
                userAuth.fullName
                  ? userAuth.fullName
                  : userAuth.email.split("@")[0]
              }}
            </v-list-item-title>
            <v-list-item-subtitle>Sesión iniciada</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <MenuBar />
    </v-navigation-drawer>
    <v-main>
      <router-view transition="slide-x-transition"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import MenuBar from "./components/layouts/MenuBar";
import { Config } from "./config";
export default {
  name: "App",

  components: {
    MenuBar
  },
  data: () => ({
    loading: false,
    drawer: false,
    userAuth: localStorage.getItem("userAuth")
      ? JSON.parse(localStorage.getItem("userAuth"))
      : null
  }),
  mounted() {
    // this.userAuth = {
    //   id: "jesusn@gmail.com",
    //   fullName: "Jesus"
    // };
    // localStorage.setItem("userAuth", JSON.stringify(this.userAuth));
  },
  methods: {
    logout() {
      let url = `${Config.url}/logout`;
      const FormData = require("form-data");
      const form = new FormData();
      this.axios.post(url, form, { withCredentials: true }).then(res => {
        console.log(res);
        this.loading = true;
        localStorage.removeItem("userAuth");
        location.reload();
      });
    }
  }
};
</script>
